const copyToClipboard = (value, callback = (isSuccessful) => null) => {
  const tempTextArea = document.createElement('textarea');
  tempTextArea.style.cssText = 'position: absolute; left: -9999px; top: 0; opacity: 0';
  tempTextArea.setAttribute('readonly', '');
  tempTextArea.value = value;

  document.body.appendChild(tempTextArea);

  tempTextArea.select();
  tempTextArea.setSelectionRange(0, tempTextArea.value.length); // For iOS

  const isSuccessful = document.execCommand('copy');

  document.body.removeChild(tempTextArea);

  callback(isSuccessful);
};

export default copyToClipboard;
